// extracted by mini-css-extract-plugin
export default {"footer":"K_Y","row":"K_dm","menu-column":"K_dn"};